// app/lib/money.js
// ─────────────────────────────────────────────────────────────────────────
// Arrondi financier centralisé (R9). UNE seule fonction round2 pour tout le
// projet : tout calcul monétaire s'arrondit à 2 décimales de façon identique.
//
// Forme défensive : pour un nombre valide, comportement identique à
// `Math.round(n * 100) / 100`. Pour null / undefined / valeur non numérique,
// renvoie 0 (au lieu de NaN) — évite qu'un NaN se propage sur une fiche/facture.
//
// ❌ NE PAS redéfinir round2 localement dans un fichier → import depuis ici.
// ─────────────────────────────────────────────────────────────────────────

/**
 * Arrondit un montant à 2 décimales.
 * @param {number|string|null|undefined} n
 * @returns {number} montant arrondi à 2 décimales (0 si non numérique)
 */
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export default round2;
